// @flow
import React, { useState } from 'react';

import FidTabs from 'components/profile/Fidelite/fidTabs';
import FidExplanationBadges from 'containers/profile/Fidelite/fidExplanationBadges';
import { explanationModalLinks } from 'constants/fidConstants';

type Props = {
  content: any,
  hideModal: () => void
};

function FidExplanationModal({ content, hideModal }: Props) {
  const [currentTab, setCurrentTab] = useState(content.tab);

  return (
    <div className="modal-content fid-modal fid-modal--explanation">
      <i className="icon icon-close js-closeModal" onClick={hideModal} role="button" tabIndex="0" />
      <div className="modal__wrapper">
        <div className="modal__body modal__body--medium narrow-2">
          <FidTabs activeTab={currentTab} links={explanationModalLinks} onClick={value => setCurrentTab(value)} />

          {currentTab === 'badges' && <FidExplanationBadges />}
        </div>
      </div>
    </div>
  );
}

export default FidExplanationModal;
